import { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from 'utils/@reduxjs/toolkit';
import { Toaster, ToasterBarTypeState } from './types';

export const initialState: ToasterBarTypeState = {
  open: false,
  toaster: undefined,
  toasterQueue: [],
};

const slice = createSlice({
  name: 'toasterBar',
  initialState,
  reducers: {
    showToast(state, action: PayloadAction<Toaster>) {
      if (!state.toaster) {
        state.toaster = action.payload;
        state.open = true;
      } else {
        state.toasterQueue.push(action.payload);
      }
    },
    shiftToast(state) {
      if (state.toasterQueue.length > 0) {
        state.toaster = state.toasterQueue.shift();
        state.open = true;
      }
    },
    hideToast(state) {
      state.open = false;
      state.toaster = undefined;
    },
  },
});

export const { actions: toasterBarActions, reducer: toasterBarReducer } = slice;

export const useToasterBarSlice = () => ({ actions: slice.actions });

/**
 * Example Usage:
 *
 * export function MyComponentNeedingThisSlice() {
 *  const { actions } = useToasterBarSlice();
 *
 *  const onButtonClick = (evt) => {
 *    dispatch(actions.someAction());
 *   };
 * }
 */
